import { React } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import CourseLandingPageExperience from "./CourseLandingPageExperience";
import CourseLandingPageReviews from "./CourseLandingPageReviews";
import CourseLandingPageInstructor from "./CourseLandingPageInstructor";
import CourseLandingPageFAQ from "./CourseLandingPageFAQ";
import Button from "@mui/material/Button";
import urls from "../../../../../config/urls";

function CourseLandingPageSectionMain({ data }) {
  const navigate = useNavigate();

  const { instructors, settings, media } = data;
  const { reviews, faqs } = settings;
  const { resource } = media;

  const bannerImageURL = "https://instituteofcatholicculture.net/wp-content/uploads/2026/07/the-proverbial-student-banner.jpg";

  const routeUser = () => {
    if (window.location.pathname.includes("/landing/")) {
      let slug = window.location.pathname.replace("/landing/", "");
      if (slug.endsWith("/")) {
        slug = slug.slice(0, -1);
      }
      navigate(`${urls.courseApplication}?slug=${slug}`);
    }
  }

  return (
    <div className="CourseLandingPageSection-main">
      <CourseLandingPageInstructor instructors={instructors} resource={resource} title={data.title}/>
      <CourseLandingPageReviews reviews={reviews}/>

      <div className="section-banner">
        <div className="container-banner">
          <img className="banner-image" src={bannerImageURL} alt="appyl-here-banner"/>
          <div className="banner-content">
            <p>Ready to apply?<span className="light"> It only takes a minute and is </span>completely free</p>
            <Button variant="outlined" color="inherit" onClick={() => routeUser()}>Apply</Button>
          </div>
        </div>
      </div>

      <CourseLandingPageExperience />
      <CourseLandingPageFAQ faqs={faqs}/>
    </div>
  )
}

CourseLandingPageSectionMain.propTypes = {
    data: PropTypes.object
}

export default CourseLandingPageSectionMain;